import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";

function Searchbar(props: { search: (refNum: string, firstName: string, lastName: string, companyName: string) => void }) {
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [companyName, setCompanyName] = useState<string>("");
    const [refNum, setRefNum] = useState<string>("");

    const search = () => {
        props.search(refNum, firstName, lastName, companyName);
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.currentTarget.blur();
        }
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>Search</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-row justify-start">
                <Input type="text" placeholder="Reference Number" value={refNum} onChange={(e) => setRefNum(e.target.value)} className="basis-64 mr-2" onBlur={search} onKeyDown={onKeyDown} />
                <Input type="text" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="basis-64 mx-2" onBlur={search} onKeyDown={onKeyDown} />
                <Input type="text" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.currentTarget.value)} className="basis-64 mx-2" onBlur={search} onKeyDown={onKeyDown}/>
                <Input type="text" placeholder="Company Name" value={companyName} onChange={(e) => setCompanyName(e.currentTarget.value)} className="basis-64 mx-2" onBlur={search} onKeyDown={onKeyDown}/>
            </CardContent>
        </Card>
    )
}

export default Searchbar;